import UserPasswordContainer from './UserPasswordContainer';

export default UserPasswordContainer;
